export enum SearchFilterAgeGroupType {
  ALL = 'all',
  CHILD = 'child',
  TEENAGER = 'teenager',
  ADULT = 'adult',
}

export interface SearchFilterAgeRange {
  minAge?: number;
  maxAge?: number;
}

export const SearchFilterAgeGroupMap: Record<SearchFilterAgeGroupType, string> = {
  [SearchFilterAgeGroupType.ALL]: 'Todas as idades',
  [SearchFilterAgeGroupType.CHILD]: 'Crianças (0 a 9 anos)',
  [SearchFilterAgeGroupType.TEENAGER]: 'Adolescentes (10 a 19 anos)',
  [SearchFilterAgeGroupType.ADULT]: 'Adultos (20 anos ou mais)',
};

export const searchFilterAgeGroupOptions: SearchFilterAgeGroupType[] = [
  SearchFilterAgeGroupType.ALL,
  SearchFilterAgeGroupType.CHILD,
  SearchFilterAgeGroupType.TEENAGER,
  SearchFilterAgeGroupType.ADULT,
];

export const SearchFilterAgeGroupRangeMap: Record<SearchFilterAgeGroupType, SearchFilterAgeRange> = {
  [SearchFilterAgeGroupType.ALL]: {},
  [SearchFilterAgeGroupType.CHILD]: { minAge: 0, maxAge: 9 },
  [SearchFilterAgeGroupType.TEENAGER]: { minAge: 10, maxAge: 19 },
  [SearchFilterAgeGroupType.ADULT]: { minAge: 20 },
};

export const AGE_GROUP_ANALYTICS_KEY = 'faixa_etaria';

export const SearchFilterAgeGroupAnalyticsMap: Record<SearchFilterAgeGroupType, string> = {
  [SearchFilterAgeGroupType.ALL]: 'todas',
  [SearchFilterAgeGroupType.CHILD]: 'crianca_0_9',
  [SearchFilterAgeGroupType.TEENAGER]: 'adolescente_10_19',
  [SearchFilterAgeGroupType.ADULT]: 'adulto_20_mais',
};
